// Recovered compiled webpack factory 35439. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      ReadonlyURLSearchParams: function () {
        return c;
      },
      RedirectType: function () {
        return a.RedirectType;
      },
      forbidden: function () {
        return i.forbidden;
      },
      notFound: function () {
        return o.notFound;
      },
      permanentRedirect: function () {
        return n.permanentRedirect;
      },
      redirect: function () {
        return n.redirect;
      },
      unauthorized: function () {
        return s.unauthorized;
      },
      unstable_isUnrecognizedActionError: function () {
        return f;
      },
      unstable_rethrow: function () {
        return l.unstable_rethrow;
      },
    }));
  let n = r(86542),
    a = r(86437),
    o = r(42542),
    i = r(71099),
    s = r(6640),
    l = r(3860);
  class u extends Error {
    constructor() {
      super(
        "Method unavailable on `ReadonlyURLSearchParams`. Read more: https://nextjs.org/docs/app/api-reference/functions/use-search-params#updating-searchparams",
      );
    }
  }
  class c extends URLSearchParams {
    append() {
      throw new u();
    }
    delete() {
      throw new u();
    }
    set() {
      throw new u();
    }
    sort() {
      throw new u();
    }
  }
  function f() {
    throw Object.defineProperty(
      Error("`unstable_isUnrecognizedActionError` can only be used on the client."),
      "__NEXT_ERROR_CODE",
      { value: "E776", enumerable: !1, configurable: !0 },
    );
  }
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
